<form autocomplete="off" [formGroup]="formDetails" novalidate>
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="
        border-bottom: 1px solid #dee2e6;
        justify-content: space-between;
        align-items: center;
      ">
        <div class="col">
          <div class="row">
            <div class="col">

              <h4 class="mb-0">
                Agregar productos


              </h4>


            </div>


          </div>
        </div>




        <div class="col">
          <div class="row justify-content-end">
            <div class="col d-flex align-items-center" style="max-width: 165px;">
              <p class="m-0"><small>
                  <mdb-checkbox formControlName="esProductoLibre">Producto sin SKU</mdb-checkbox>
                </small></p>
            </div>
            <div class="col d-flex justify-content-end" style="max-width: 280px;">
              <button class="mr-0" type="button" mdbBtn color="default" size="sm" (click)="showModalNoFacturable()"
                mdbWavesEffect [disabled]="!cliente">
                Producto no facturable
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="filtros-body">


        <ng-container *ngIf="formDetails.get('esProductoLibre').value" formGroupName="productoLibre">
          <div class="row">
            <div class="col" style="max-width: 100px;">
              <div class="md-form">
                <input value="" type="text" id="codProductLibre" class="form-control" placeholder="000" required
                  #codProductLibre formControlName="codigo" monto />
                <label for="codProductLibre">Código de producto</label>
                <div *ngIf="
                    formDetails.get('productoLibre.codigo').invalid &&
                    (formDetails.get('productoLibre.codigo').dirty ||
                    formDetails.get('productoLibre.codigo').touched)
                  ">
                  <mdb-error *ngIf="formDetails.get('productoLibre.codigo').hasError('required')">Ingrese código de
                    producto
                  </mdb-error>
                  <mdb-error *ngIf="formDetails.get('productoLibre.codigo').hasError('min')">Código de producto debe ser
                    mayor a 0 </mdb-error>
                </div>
              </div>
            </div>

            <div class="col" style="max-width: 300px;">
              <div class="md-form">
                <input value="" type="text" id="descripcionProductoLibre" class="form-control" placeholder="" required
                  #descripcionProductoLibre formControlName="descripcion" />
                <label for="descripcionProductoLibre">Descripción</label>
                <div *ngIf="
                    formDetails.get('productoLibre.descripcion').invalid &&
                    (formDetails.get('productoLibre.descripcion').dirty ||
                    formDetails.get('productoLibre.descripcion').touched)
                  ">
                  <mdb-error *ngIf="formDetails.get('productoLibre.descripcion').hasError('required')">
                    Ingrese descripción de producto
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 150px;">
              <div class="md-form">
                <mdb-select [options]="optionsFormatoProductoLibre" [multiple]="false" [filterEnabled]="false"
                  [highlightFirst]="false" placeholder="Seleccionar formato" formControlName="formato"></mdb-select>
                <label>Formato</label>
                <div *ngIf="
                    formDetails.get('productoLibre.formato').invalid &&
                    (formDetails.get('productoLibre.formato').dirty ||
                    formDetails.get('productoLibre.formato').touched)
                  ">
                  <mdb-error *ngIf="formDetails.get('productoLibre.formato').hasError('required')">Ingrese formato
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 100px;">
              <div class="md-form">
                <input value="" type="text" id="cant" class="form-control" placeholder="Ingrese cantidad" required #cant
                  formControlName="cantidad" monto />
                <label for="cant">Cantidad</label>
                <div *ngIf="
                    formDetails.get('productoLibre.cantidad').invalid &&
                    (formDetails.get('productoLibre.cantidad').dirty ||
                    formDetails.get('productoLibre.cantidad').touched)
                  ">
                  <mdb-error *ngIf="formDetails.get('productoLibre.cantidad').hasError('required')">Ingrese cantidad
                  </mdb-error>
                  <mdb-error *ngIf="formDetails.get('productoLibre.cantidad').hasError('min')">Cantidad debe ser mayor a
                    0
                  </mdb-error>
                  <mdb-error
                    *ngIf="formDetails.get('productoLibre.cantidad').value > 1 &&  formDetails.get('productoLibre.formato').value && formDetails.get('productoLibre.formato').value.includes('MED')">
                    La cantidad debe ser 1 o menos cuando el formato contiene 'MED'
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 200px;">
              <div class="">
                <input value="" type="text" id="precioUnitario" class="form-control" placeholder="000" required
                  #precioUnitario formControlName="precioUnitario" monto />
                <label for="precioUnitario">Precio unitario</label>
                <div *ngIf="
                    formDetails.get('productoLibre.precioUnitario').invalid &&
                    (formDetails.get('productoLibre.precioUnitario').dirty ||
                    formDetails.get('productoLibre.precioUnitario').touched)
                  ">
                  <mdb-error *ngIf="formDetails.get('productoLibre.precioUnitario').hasError('required')">
                    Ingrese precio unitario
                  </mdb-error>
                  <mdb-error *ngIf="formDetails.get('productoLibre.precioUnitario').hasError('min')">
                    Precio unitario debe ser mayor a 0
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col">
              <!-- Material inline 1 -->
              <div class="form-check form-check-inline" style="margin-right: 20px;">
                <input type="radio" class="form-check-input" mdbInput id="producto_libre_afecto"
                  [value]="PRODUCTO_LIBRE_AFECTO" formControlName="es_exento" />
                <label class="form-check-label" for="producto_libre_afecto">Afecto</label>
              </div>

              <!-- Material inline 2 -->
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" mdbInput id="producto_libre_exento"
                  [value]="PRODUCTO_LIBRE_EXCENTO" formControlName="es_exento" />
                <label class="form-check-label" for="producto_libre_exento">Exento</label>
              </div>
            </div>
          </div>

        </ng-container>

        <div class="row" formGroupName="productoExistente" *ngIf="!formDetails.get('esProductoLibre').value">
          <div class="col" style="max-width: 100px;">
            <div class="md-form">
              <input value="" type="text" id="codProduct" class="form-control" placeholder="000" required #codProduct
                formControlName="codigo" />
              <label for="codProduct">Código de producto</label>
              <div *ngIf="
                    formDetails.get('productoExistente.codigo').invalid &&
                    (formDetails.get('productoExistente.codigo').dirty ||
                    formDetails.get('productoExistente.codigo').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('productoExistente.codigo').hasError('required')">Ingrese código de
                  producto
                </mdb-error>
                <mdb-error *ngIf="formDetails.get('productoExistente.codigo').hasError('min')">Código de producto debe
                  ser
                  mayor a 0 </mdb-error>
              </div>
            </div>
          </div>
          <div class="col d-flex" style="max-width: 300px;">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="abrirModalSeleccionarProducto()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
            <h6 class="text-info" *ngIf="detailsData?.productoSeleccionado" style="display: contents;">
              {{ detailsData.productoSeleccionado.descripcion}}
            </h6>
          </div>
          <div class="col" style="max-width: 150px;">
            <div class="md-form">
              <mdb-select [options]="optionsFormato" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
                placeholder="Seleccionar formato" formControlName="formato"></mdb-select>
              <label>Formato</label>
              <div *ngIf="
                                        formDetails.get('productoExistente.formato').invalid &&
                                        (formDetails.get('productoExistente.formato').dirty ||
                                        formDetails.get('productoExistente.formato').touched)
                                      ">
                <mdb-error *ngIf="formDetails.get('productoExistente.formato').hasError('required')">Ingrese formato
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col" style="max-width: 100px;">
            <div class="md-form">
              <input value="" type="text" id="cant" class="form-control" placeholder="Ingrese cantidad" required #cant
                formControlName="cantidad" monto />
              <label for="cant">Cantidad</label>
              <div *ngIf="
                                        formDetails.get('productoExistente.cantidad').invalid &&
                                        (formDetails.get('productoExistente.cantidad').dirty ||
                                        formDetails.get('productoExistente.cantidad').touched)
                                      ">
                <mdb-error *ngIf="formDetails.get('productoExistente.cantidad').hasError('required')">Ingrese cantidad
                </mdb-error>
                <mdb-error *ngIf="formDetails.get('productoExistente.cantidad').hasError('min')">Cantidad debe ser mayor
                  a 0
                </mdb-error>
                <mdb-error
                  *ngIf="formDetails.get('productoExistente.cantidad').value > 1 &&  formDetails.get('productoExistente.formato').value && formDetails.get('productoExistente.formato').value.includes('MED')">
                  La cantidad debe ser 1 o menos cuando el formato contiene 'MED'
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col" style="max-width: 200px;">
            <Strong class="title">Precio unitario</Strong>
            <span class="value monto" *ngIf="formDetails.get('productoExistente.precioUnitario').value !== null">
              $ {{formDetails.get('productoExistente.precioUnitario').value | numerico }}</span>
            <span class="value monto" *ngIf="formDetails.get('productoExistente.precioUnitario').value === null"></span>
            <div *ngIf="
                                      formDetails.get('productoExistente.precioUnitario').invalid &&
                                      (formDetails.get('productoExistente.precioUnitario').dirty ||
                                      formDetails.get('productoExistente.precioUnitario').touched)
                                    ">
              <mdb-error *ngIf="formDetails.get('productoExistente.precioUnitario').hasError('required')">
                Ingrese precio unitario
              </mdb-error>
            </div>
          </div>
        </div>



        <div class="row">
          <div class="col" style="max-width: 400px;" formGroupName="descuento"
            *ngIf="!formDetails.get('esProductoLibre').value">
            <div class="row">
              <div class="col" style="max-width: 150px; display: flex; align-items: center;">
                <h5>Descuento</h5>
              </div>


              <div class="col dcto-box">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">%</div>
                  </div>
                  <input mdbInput type="text" id="descuentoPorcent" class="form-control py-0" #descuentoPorcent
                    decimales formControlName="porcentaje">
                  <!-- <div *ngIf="formHeader.get('descuento.porcentaje').invalid &&
                                                                        (formHeader.get('descuento.porcentaje').dirty ||
                                                                        formHeader.get('descuento.porcentaje').touched)
                                                                      ">
                    <mdb-error *ngIf="formHeader.get('descuento.porcentaje').hasError('min')">Valor debe ser
                      mayor a 0
                    </mdb-error>
                    <mdb-error
                      *ngIf="formHeader.get('descuento.porcentaje').hasError('max') && headerData.clienteSeleccionado && headerData.clienteSeleccionado.descuento_maximo">
                      Valor no puede ser mayor a {{headerData.clienteSeleccionado.descuento_maximo }}
                    </mdb-error>
                  </div> -->
                </div>
              </div>


              <div class="col dcto-box">

                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">$</div>
                  </div>
                  <input mdbInput type="text" id="descuentoPesos" class="form-control py-0" #descuentoPesos monto
                    formControlName="monto">
                  <!-- <div *ngIf="
                                                        formHeader.get('descuento.monto').invalid &&
                                                        (formHeader.get('descuento.monto').dirty ||
                                                        formHeader.get('descuento.monto').touched)
                                                      ">
    <mdb-error *ngIf="formHeader.get('descuento.monto').hasError('min')">Valor debe ser mayor
      a 0
    </mdb-error>
  </div> -->
                </div>




              </div>
            </div>
          </div>
          <div class="col" formGroupName="recargo" *ngIf="!formDetails.get('esProductoLibre').value">
            <div class="row">
              <div class="col" style="max-width: 150px; display: flex; align-items: center;">
                <h5>Recargo</h5>
              </div>
              <div class="col dcto-box">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">%</div>
                  </div>
                  <input mdbInput type="text" id="recargoPorcent" class="form-control py-0" #recargoPorcent decimales
                    formControlName="porcentaje">
                  <!-- <div *ngIf="
                                                                                              formHeader.get('recargo.porcentaje').invalid &&
                                                                                              (formHeader.get('recargo.porcentaje').dirty ||
                                                                                              formHeader.get('recargo.porcentaje').touched)
                                                                                            ">
                    <mdb-error *ngIf="formHeader.get('recargo.porcentaje').hasError('min')">Valor debe ser
                      mayor a 0
                    </mdb-error>
                  </div> -->
                </div>
              </div>
              <div class="col dcto-box">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">$</div>
                  </div>
                  <input mdbInput type="text" id="recargoPorcent" class="form-control py-0" #recargoPorcent monto
                    formControlName="monto">
                  <!-- <div *ngIf="
                                                                                              formHeader.get('recargo.monto').invalid &&
                                                                                              (formHeader.get('recargo.monto').dirty ||
                                                                                              formHeader.get('recargo.monto').touched)
                                                                                            ">
                    <mdb-error *ngIf="formHeader.get('recargo.monto').hasError('min')">Valor debe ser mayor a
                      0
                    </mdb-error>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect
        *ngIf="!formDetails.get('esProductoLibre').value" (click)="agregarProductoGenerico('NORMAL')"
        [disabled]="!cliente || !detailsData || !detailsData.productoSeleccionado">
        Agregar producto
      </button>
      <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect
        *ngIf="formDetails.get('esProductoLibre').value" (click)="agregarProductoGenerico('LIBRE')"
        [disabled]="!cliente">
        Agregar producto sin SKU
      </button>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow" *ngIf="detalleDocumento?.length > 0">
  <div class="card-body">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">
                  <mdb-checkbox (change)="checkAllChange($event)"></mdb-checkbox>
                </th>
                <th scope="col">Código</th>
                <th scope="col">Descripción</th>
                <th scope="col">Cantidad</th>
                <th scope="col">Formato</th>
                <th scope="col">Precio</th>
                <th scope="col">Descuento</th>
                <th scope="col">Recargo</th>
                <th scope="col">Total</th>
                <!-- <th></th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detalle of detalleDocumento">
                <td>
                  <mdb-checkbox [checked]="detalle.eliminar_linea" (change)='checkDetalle(detalle)'></mdb-checkbox>
                </td>

                <td *ngIf="detalle.sku && detalle.sku !=='0'">{{ detalle.sku }}</td>
                <td *ngIf="!detalle.sku || detalle.sku ==='0'"></td>

                <td>{{ detalle.descripcion_producto }}</td>
                <td *ngIf="detalle.es_promocion">{{ detalle.cantidad | numerico }}</td>

                <td *ngIf="!detalle.es_promocion">
                  <div class="m-0" style="max-width: 100px;">
                    <input value="" type="text" class="form-control" required monto min="1"
                      [(ngModel)]="detalle.cantidad" name="cantidad" #cantidad="ngModel" [readonly]=""
                      [disabled]="detalle.sku === '0'" (input)="updateChange(detalle)" />
                    <mdb-error *ngIf="detalle.cantidad === ''">
                      Cantidad no válida
                    </mdb-error>
                    <!-- <mdb-error *ngIf="!cantidad.valid && !additionalHeaderInfo?.denyEditCantidad">
                      Ingrese cantidad
                    </mdb-error> -->
                  </div>
                </td>
                <td>{{ detalle.formato_nombre }}</td>
                <td>$ {{ detalle.precio_unitario | numerico }}</td>

                <!-- <td *ngIf="detalle.descuento_linea_pesos > 0">$ {{ detalle.descuento_linea_pesos | numerico }}</td>
                <td *ngIf="detalle.descuento_linea_porcentaje > 0">{{ detalle.descuento_linea_porcentaje / 100 |
                  percent }}</td>
                <td *ngIf="detalle.descuento_linea_pesos === 0 && detalle.descuento_linea_porcentaje === 0">$ 0</td> -->
                <td>$ {{ detalle.aplicacion_descuento | numerico }}</td>

                <!-- <td *ngIf="detalle.recargo_linea_pesos > 0">$ {{ detalle.recargo_linea_pesos | numerico }}</td>
                <td *ngIf="detalle.recargo_linea_porcentaje > 0">{{ detalle.recargo_linea_porcentaje / 100 | percent
                  }}</td>
                <td *ngIf="detalle.recargo_linea_pesos === 0 && detalle.recargo_linea_porcentaje === 0">$ 0</td> -->
                <td>$ {{ detalle.aplicacion_recargo | numerico }}</td>

                <td>$ {{ detalle.monto_total_neto | numerico }}</td>
                <!-- <td>
                  <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect>
                    <mdb-icon fas icon="trash" (click)="eliminarDetalle(detalle)"></mdb-icon>
                  </button>
                </td> -->
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col">
              <button type="button" class="btn btn-warning waves-light" data-dismiss="modal" mdbWavesEffect
                (click)="eliminarSeleccionados()" [disabled]="disableEliminar">
                Eliminar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="totalesDocumento && detalleDocumento?.length > 0">
      <div class="col">
        <div class="table-responsive mt-1">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="blue lighten-5">
              <tr>
                <th scope="col">SubTotal</th>
                <th scope="col">Descto.</th>
                <th scope="col">Recargo</th>
                <th scope="col">impto. Adic.</th>
                <th scope="col">Afecto</th>
                <th scope="col">Exento</th>
                <th scope="col">Neto</th>
                <th scope="col">IVA</th>
                <th scope="col">TOTAL</th>
              </tr>
            </thead>
            <tbody class="blue lighten-5">
              <tr>
                <td>$ {{ totalesDocumento.subtotal | numerico }}</td>
                <td>$ {{ totalesDocumento.descuento | numerico }}</td>
                <td>$ {{ totalesDocumento.recargo | numerico }}</td>
                <td>$ {{ totalesDocumento.impto_adic }}</td>
                <td>$ {{ totalesDocumento.afecto | numerico }}</td>
                <td>$ {{ totalesDocumento.exento | numerico }}</td>
                <td>$ {{ totalesDocumento.neto | numerico }}</td>
                <td>$ {{ totalesDocumento.iva | numerico }}</td>
                <td><strong>$ {{ totalesDocumento.total | numerico }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL agregarNoFacturable -->
<div mdbModal #agregarNoFacturable="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog" role="document">
    <form autocomplete="off" [formGroup]="formNoFactuable" novalidate
      (ngSubmit)="agregarProductoGenerico('NO_FACTURABLE')">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Agregar producto no facturable
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hideModalNoFacturable()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="nombreProduct" class="form-control" placeholder="Nombre del producto"
                  required #nombreProduct formControlName="nombre" />
                <label for="nombreProduct">Nombre del producto</label>
                <div *ngIf="
                formNoFactuable.get('nombre').invalid &&
                (formNoFactuable.get('nombre').dirty ||
                formNoFactuable.get('nombre').touched)
              ">
                  <mdb-error *ngIf="formNoFactuable.get('nombre').hasError('required')">
                    Ingrese nombre de producto
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
            (click)="hideModalNoFacturable()" mdbWavesEffect>
            Cerrar
          </button>
          <button type="submit" class="btn btn-secondary waves-light" mdbWavesEffect>
            Agregar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>



<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto [showFiltroActivoInactivo]="false" (onSelect)="onProductoSeleccionado($event)"
  (onNotFound)="onProductoNoEncontrado()" (onRemoteQuery)="getProducts($event)">
</app-modal-seleccionar-producto>

<app-modal-confirm title="Eliminar productos(s)" contentText="¿Desea eliminar productos(s)?">
</app-modal-confirm>